module.exports = __webpack_public_path__ + "media/images/openstreetmap/NT2-fe8baaa39f08caa32db65cb46a7c3d97.png";